import * as React from "react";
const SvgPlusClear = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 14", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "inherit", fillRule: "nonzero", d: "M14 8H8v6H6V8H0V6h6V0h2v6h6z" }));
export default SvgPlusClear;
